import React, { memo, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { fetchPaymentReturn } from "ducks/actions";
import {
  makeSelectPaymentReturn,
  makeSelectIsFetchingData,
  makeSelectIsPaymentPending,
  makeSelectIsPaymentSuccess,
  makeSelectIsPaymentFailed,
  makeSelectAppSettings,
  makeSelectSessionToken
} from "ducks/selectors";
import Spinner, { styles } from "components/Spinner";
import { urlParam } from "utils/helpers";
import PaymentSuccess from "./PaymentSuccess";
import PaymentFailure from "./PaymentFailure";
import PaymentPending from "./PaymentPending";

export const PaymentReturn = props => {
  const {
    order,
    isPaymentPending,
    isPaymentFailed,
    isPaymentSuccess,
    fetchPaymentReturn,
    isFetchingPaymentReturn,
    appSettings,
    token
  } = props;
  const status = urlParam("status");

  useEffect(
    () => {
      if (token) {
        fetchPaymentReturn(token);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [token]
  );

  if (isFetchingPaymentReturn) {
    return <Spinner size={200} sx={styles.fullPage} />;
  } else {
    if (isPaymentPending) {
      return <PaymentPending status={status} {...props} />;
    }

    if (isPaymentFailed) {
      return <PaymentFailure status={status} {...props} />;
    }

    if (isPaymentSuccess) {
      return (
        <PaymentSuccess appSettings={appSettings} status={status} {...order} />
      );
    }
    return <></>;
  }
};

const mapStateToProps = createStructuredSelector({
  order: makeSelectPaymentReturn(),
  isFetchingPaymentReturn: makeSelectIsFetchingData("paymentReturn"),
  isPaymentPending: makeSelectIsPaymentPending(),
  isPaymentSuccess: makeSelectIsPaymentSuccess(),
  isPaymentFailed: makeSelectIsPaymentFailed(),
  appSettings: makeSelectAppSettings(),
  token: makeSelectSessionToken()
});

export function mapDispatchToProps(dispatch) {
  return {
    fetchPaymentReturn: token => {
      let params = { order_ref: urlParam("order_ref"), token };
      const type = urlParam("type");
      if (type) {
        params["type"] = type;
      }
      params["source"] = "payment_return";
      dispatch(fetchPaymentReturn(params));
    }
  };
}

PaymentReturn.defaultProps = {
  fetchPaymentReturn: () => {}
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect, memo)(PaymentReturn);
